{
  "appTitle": "Real Estate Tracker",
  "footer": "Suivi d'annonces immobilières © 2026",
  "nav": {
    "ads": "Annonces",
    "criteria": "Critères",
    "mortgage": "Hypothèque",
    "scraping": "Collecte",
    "administration": "Administration"
  },
  "userMenu": {
    "role": "Rôle : {{role}}",
    "logout": "Déconnexion"
  },
  "logoutDialog": {
    "title": "Déconnexion",
    "message": "Voulez-vous vraiment vous déconnecter ?",
    "confirm": "Déconnexion"
  },
  "language": {
    "label": "Langue",
    "en": "English",
    "fr": "Français",
    "ro": "Română"
  },
  "formatters": {
    "notAvailable": "N/D",
    "invalidDate": "Date invalide",
    "justNow": "à l'instant",
    "minuteAgo_one": "il y a {{count}} minute",
    "minuteAgo_many": "il y a {{count}} minutes",
    "minuteAgo_other": "il y a {{count}} minutes",
    "hourAgo_one": "il y a {{count}} heure",
    "hourAgo_many": "il y a {{count}} heures",
    "hourAgo_other": "il y a {{count}} heures",
    "dayAgo_one": "il y a {{count}} jour",
    "dayAgo_many": "il y a {{count}} jours",
    "dayAgo_other": "il y a {{count}} jours",
    "weekAgo_one": "il y a {{count}} semaine",
    "weekAgo_many": "il y a {{count}} semaines",
    "weekAgo_other": "il y a {{count}} semaines",
    "monthAgo_one": "il y a {{count}} mois",
    "monthAgo_many": "il y a {{count}} mois",
    "monthAgo_other": "il y a {{count}} mois",
    "yearAgo_one": "il y a {{count}} an",
    "yearAgo_many": "il y a {{count}} ans",
    "yearAgo_other": "il y a {{count}} ans",
    "roomStudio": "0,5 pièce (studio)",
    "room_one": "{{count}} pièce",
    "room_many": "{{count}} pièces",
    "room_other": "{{count}} pièces",
    "today": "aujourd'hui",
    "yesterday": "hier"
  },
  "priceDisplay": {
    "tooltip": "Le prix est passé de {{previous}} à {{current}} ({{when}})"
  },
  "aria": {
    "menu": "menu",
    "accountMenu": "menu du compte"
  },
  "errors": {
    "forbiddenTitle": "403 - Accès refusé",
    "forbiddenMessage": "Vous n'avez pas la permission d'accéder à cette page.",
    "notFound": "404 - Page introuvable"
  },
  "status": {
    "new": "Nouveau",
    "not_interested": "Pas intéressé",
    "interested_to_visit": "Intéressé pour visiter",
    "visit_scheduled": "Visite planifiée",
    "visited": "Visité",
    "discarded": "Écarté",
    "interested_to_buy": "Intéressé pour acheter",
    "bought": "Acheté",
    "retired": "Retiré — plus disponible"
  },
  "actions": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "close": "Fermer",
    "confirm": "Confirmer",
    "back": "Retour",
    "retry": "Réessayer"
  }
}
